module.exports = __webpack_public_path__ + "static/media/trieste-16.52b0fcc0.jpg";